module.exports = __webpack_public_path__ + "img/K16Pro.ed1e092f.jpg";